var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeModule === 'all-actions')?_c('all-actions'):_vm._e(),(_vm.activeModule === 'transition-maps')?_c('transition-maps'):_vm._e(),(_vm.activeModule === 'transition-review')?_c('transition-review'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }